import React from 'react'
import { Dropdown, HeaderGlobalBar, Select, SelectItem } from 'carbon-components-react'
import LanguageSwitch from '../../../LanguageSwitch'
// import ThemeSwitch from '../../../ThemeSwitch'
import './index.scss'
import { isEmpty } from 'lodash'

export default function HeaderActions({
  i18nControls,
  multiProjectControls = {},
  extraActionComponents = []
}) {

  const {projects, selectedProject, onProjectChange} = multiProjectControls

  return (
    <HeaderGlobalBar>
      {multiProjectControls && !isEmpty(projects) && (
        <div className='multi_project__wrapper'>
          <Dropdown
            id='multi-project-select'
            className='multi-project'
            items={projects}
            selectedItem={selectedProject}
            onChange={({ selectedItem }) => onProjectChange(selectedItem)}
            label=''
            type='inline'
          />
        </div>
      )}
      {extraActionComponents}
      {i18nControls && (
        <LanguageSwitch
          selectedLanguage={i18nControls.selectedLanguage}
          onChange={i18nControls.onLanguageChange}
          languages={i18nControls.languages}
          shortLanguage
        />
      )}
      {/* themeSelection && (
        <ThemeSwitch
          themes={themeSelection.themes}
          onChange={themeSelection.onThemeChange}
          selectedTheme={themeSelection.selectedTheme}
        />
      ) */}
    </HeaderGlobalBar>
  )
}